import React from "react"
import { Outlet, useLocation } from "react-router-dom"

import Footer from "../components/Common/Footer"
import Header from "../components/Common/Header"

const LoginLayout = () => {
    const location = useLocation()
    const isLoginRoute = (location.pathname === "/" || location.pathname === "/registration" || location.pathname === "/dashboard")
    const isHomeRoute = (location.pathname === "/home")
    return (
        <div className={ `${isLoginRoute ? " pt-[76px]" : "pt-[120px]"} bg-white dark:bg-darkBg text-black dark:text-white min-h-screen` }>
            { !isHomeRoute && ( <Header /> ) }
            <div className="flex pt-4 gap-6 bg-primary-200 dark:bg-darkCard w-full">
                <main className=" w-full flex flex-col justify-center">
                    <Outlet />
                </main>
            </div>
            { !isHomeRoute && (<Footer />) }
        </div>
    )
}

export default LoginLayout
